import { authFetch } from './authFetch';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

export interface LocationConfig {
    ghl_id: string;
    location_emr_id: string;
}

export const locationConfigApi = {
    async get(ghId: string): Promise<LocationConfig> {
        const response = await authFetch(`${API_BASE_URL}/ghl-location-config/${encodeURIComponent(ghId)}`);
        if (!response.ok) throw new Error('Failed to load location config');
        return response.json();
    },

    async upsert(ghId: string, locationEmrId: string): Promise<LocationConfig> {
        const response = await authFetch(`${API_BASE_URL}/ghl-location-config/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ghl_id: ghId, location_emr_id: locationEmrId }),
        });
        if (!response.ok) throw new Error('Failed to save location config');
        return response.json();
    },
};
